// video-lightbox.js  (updated: 9/16 portrait + top-right close handling)
(function () {
  var selector = '[data-fancybox^="video-"]';

  function isYouTube(url) { return /youtu\.be|youtube\.com/.test(url); }
  function isVimeo(url) { return /vimeo\.com/.test(url); }

  function createIframe(src) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('loading', 'lazy');
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.src = src;
    return iframe;
  }

  function createVideo(src) {
    var video = document.createElement('video');
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.style.width = '100%';
    video.style.height = '100%';
    var srcEl = document.createElement('source');
    srcEl.src = src;
    video.appendChild(srcEl);
    return video;
  }

  function buildModal(contentEl) {
    var overlay = document.createElement('div');
    overlay.className = 'va-lightbox-overlay';
    overlay.innerHTML = '\
      <div class="va-lightbox-panel" role="dialog" aria-modal="true" aria-label="Video preview">\
        <button class="va-lightbox-close" aria-label="Close video">&times;</button>\
        <div class="va-lightbox-content"></div>\
      </div>';
    overlay.querySelector('.va-lightbox-content').appendChild(contentEl);
    document.body.appendChild(overlay);

    // Prevent background scroll
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    return overlay;
  }

  function teardownModal(overlay) {
    if (!overlay) return;
    // pause videos if any
    var v = overlay.querySelector('video');
    if (v && !v.paused) try { v.pause(); } catch(e) {}
    // remove keydown handler if set
    if (overlay._escHandler) document.removeEventListener('keydown', overlay._escHandler);
    overlay.remove();
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function openUrl(url) {
    var content;
    if (isYouTube(url)) {
      var idMatch = url.match(/(?:v=|\/)([0-9A-Za-z_-]{6,})/);
      var id = idMatch ? idMatch[1] : null;
      var embed = id ? ('https://www.youtube.com/embed/' + id + '?autoplay=1') : url;
      content = createIframe(embed);
    } else if (isVimeo(url)) {
      var idMatch = url.match(/vimeo\.com\/([0-9]+)/);
      var id = idMatch ? idMatch[1] : null;
      var embed = id ? ('https://player.vimeo.com/video/' + id + '?autoplay=1') : url;
      content = createIframe(embed);
    } else {
      // direct video file
      content = createVideo(url);
    }

    var overlay = buildModal(content);

    var closeBtn = overlay.querySelector('.va-lightbox-close');
    closeBtn.addEventListener('click', function () { teardownModal(overlay); });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) teardownModal(overlay);
    });

    // handle Escape key, and store handler so we can remove it cleanly
    var escHandler = function (e) {
      if (e.key === 'Escape') teardownModal(overlay);
    };
    overlay._escHandler = escHandler;
    document.addEventListener('keydown', escHandler);

    // focus for accessibility
    closeBtn.focus();
  }

  function onClick(e) {
    var a = e.currentTarget;
    var href = a.getAttribute('href') || a.dataset.href;
    if (!href) return;
    e.preventDefault();
    openUrl(href);
  }

  function init() {
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;
    nodes.forEach(function (n) {
      n.addEventListener('click', onClick);
      n.style.cursor = 'pointer';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
